import { ButtonModule } from 'primeng/button';
import { HasAnyPermissionDirective } from './has-any-permission.directive';
import { CoreLibService } from './core-lib.service';
import { GraphQLModule } from './graphql.module';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { FormatFileSizePipe } from './format-filesize.pipe';
import { HasAnyClaimDirective } from './has-any-claim.directive';
import { DocLinkComponent, DocLinkDirective } from './doclink.directive';
import { MessageService } from 'primeng/api';


@NgModule({
  declarations: [
    FormatFileSizePipe,
    HasAnyClaimDirective,
    HasAnyPermissionDirective,
    DocLinkDirective,
    DocLinkComponent
  ],
  imports: [
    GraphQLModule,
    ButtonModule,
  ],
  exports: [
    GraphQLModule,
    FormatFileSizePipe,
    HasAnyPermissionDirective,
    HasAnyClaimDirective,
    DocLinkDirective
  ]
})

export class CoreLibModule {
  static forRoot(env: any): ModuleWithProviders<CoreLibModule> {
    return <ModuleWithProviders<CoreLibModule>>{
      ngModule: CoreLibModule,
      providers: [
        MessageService,
        FormatFileSizePipe,
        {
          provide: 'environment', useFactory: () => {
            return env;
          }
        },
        {
          provide: 'language',  
          useFactory: () => {
            const userLang = window.navigator.language.split('-')[0];
            return userLang;
          }
        }, 
        {
          provide: 'component', useFactory: () => {
            if (env.staticParams && env.staticParams[`component`]) {
              return env.staticParams[`component`];
            }
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const component = urlParams.get('component');
            return component;
          }
        },
        CookieService,
        {
          provide: 'jwt', useFactory: (cookieService: CookieService) => {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const jwt = urlParams.get('jwt');
            if (jwt){
              return jwt;
            }

            if (env.staticParams && env.staticParams[`jwt`]) {
              return env.staticParams[`jwt`];
            }

            if (cookieService.check('jwt')) {
              return cookieService.get('jwt');
            }

            return null; 
          }, deps: [CookieService]
        },
        CoreLibService
      ]
    };
  }
}